import React from "react";
import PageHeader from "../components/PageHeader";
import useYMMTLabels from "../hooks/useYMMTLabels";

const VehicleInfoHeader = ({ yearId, makeId, modelId, trimId, ...props }) => {
  const ymmtIds = { yearId, makeId, modelId, trimId };
  const [[year, make, model]] = useYMMTLabels(ymmtIds);
  const title =
    typeof year !== "undefined" &&
    typeof make !== "undefined" &&
    typeof model !== "undefined"
      ? `${year} ${make} ${model}`.toUpperCase()
      : "";
  return <PageHeader title={title} subheader="Tell Us About Your" {...props} />;
};

export default VehicleInfoHeader;
